import request from '@/router/axios'

export function getMaterialList(params) {
  return request({
    url: '/basic/admin/material/page',
    method: 'GET',
    params: params
  })
}

export function addMaterial(data) {
  return request({
    url: '/basic/admin/material',
    method: 'POST',
    data: data
  })
}

export function deleteMaterial(ids) {
    return request({
        url: `/basic/admin/material`,
        method: 'DELETE',
        params: {
            ids: ids
        }
    })
}

export function addMaterialTagObj (obj) {
  return request({
    url: '/basic/admin/material/tag',
    method: 'post',
    data: obj
  })
}